// Budget → Planned and the Sub-budgets page: how much of a main line's allowance its sub-budgets plan to use
import { h } from '../core/react.js';
import { T, MONO, fmt } from '../core/theme.js';
import { ccySym } from '../core/format.js';

const money = (n, c) => n == null ? '—' : ccySym(c) + fmt.num(n);
const pctText = p => p == null ? '' : Math.round(p * 100) + '%';

// how much of a main line's allowance is planned, as a bar: green, amber from 90%, red when over
export function PlanBar({ plan, compact }) {
  if (!plan) return null;
  const p = plan.pct, over = plan.over, c = over ? T.red : p >= 0.9 ? T.amber : T.green;
  const label = over ? `${money(-plan.left, plan.ccy)} over` : compact ? pctText(p) : `${money(plan.left, plan.ccy)} left`;
  return h("div", { title: `${money(plan.planned, plan.ccy)} planned of ${money(plan.allowance, plan.ccy)}${plan.parts.length ? ' (' + plan.parts.map(x => `${x.name} ${money(x.amount, plan.ccy)}`).join(', ') + ')' : ''}${plan.noRate ? '. Some lines have no exchange rate and are not counted.' : ''}`,
    style: { display: 'flex', alignItems: 'center', gap: 7 } },
    h("div", { style: { flex: 1, height: 5, background: T.ivoryD, position: 'relative', overflow: 'hidden', minWidth: 30 } },
      h("div", { style: { position: 'absolute', left: 0, top: 0, bottom: 0, width: Math.min(100, (p ?? 1) * 100) + '%', background: c } })),
    h("span", { style: { ...MONO, fontSize: 11, whiteSpace: 'nowrap', color: over ? T.red : T.coal, fontWeight: over ? 700 : 400 } }, (plan.noRate ? '! ' : '') + label));
}
